import { render, staticRenderFns } from "./dashboard-mood.vue?vue&type=template&id=dfba5960&"
import script from "./dashboard-mood.vue?vue&type=script&lang=js&"
export * from "./dashboard-mood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports